import React from 'react';

const Paginator = function ({ currentPage, totalPages, pageClickHandler }) {
  const currentPageNum = parseInt(currentPage);
  const totalPagesNum = parseInt(totalPages);

  const renderPageNumbers = () => {
    const pages = [];

    pages.push(
      <li key="page-1" className="ds_pagination__item">
        <a
          aria-label={`Page 1${currentPageNum === 1 ? ', current page' : ''}`}
          className={`ds_pagination__link ${
            currentPageNum === 1 ? 'ds_current' : ''
          }`}
          onClick={() => pageClickHandler(1)}
          href="#"
        >
          <span className="ds_pagination__link-label">1</span>
        </a>
      </li>
    );

    if (totalPagesNum <= 4) {
      for (let i = 2; i <= totalPagesNum; i++) {
        pages.push(
          <li key={`page-${i}`} className="ds_pagination__item">
            <a
              aria-label={`Page ${i}${
                currentPageNum === i ? ', current page' : ''
              }`}
              className={`ds_pagination__link ${
                currentPageNum === i ? 'ds_current' : ''
              }`}
              onClick={() => pageClickHandler(i)}
              href="#"
            >
              <span className="ds_pagination__link-label">{i}</span>
            </a>
          </li>
        );
      }
      return pages;
    }

    if (totalPagesNum > 4 && currentPageNum < 4) {
      for (let i = 2; i <= 4; i++) {
        pages.push(
          <li key={`page-${i}`} className="ds_pagination__item">
            <a
              aria-label={`Page ${i}${
                currentPageNum === i ? ', current page' : ''
              }`}
              className={`ds_pagination__link ${
                currentPageNum === i ? 'ds_current' : ''
              }`}
              onClick={() => pageClickHandler(i)}
              href="#"
            >
              <span className="ds_pagination__link-label">{i}</span>
            </a>
          </li>
        );
      }

      if (totalPagesNum > 5) {
        pages.push(
          <li
            key="ellipsis-1"
            className="ds_pagination__item"
            aria-hidden="true"
          >
            <span className="ds_pagination__link ds_pagination__link--ellipsis">
              &hellip;
            </span>
          </li>
        );
      }
    } else if (currentPageNum >= totalPagesNum - 2) {
      if (totalPagesNum > 5) {
        pages.push(
          <li
            key="ellipsis-1"
            className="ds_pagination__item"
            aria-hidden="true"
          >
            <span className="ds_pagination__link ds_pagination__link--ellipsis">
              &hellip;
            </span>
          </li>
        );
      }

      for (let i = totalPagesNum - 3; i < totalPagesNum; i++) {
        pages.push(
          <li key={`page-${i}`} className="ds_pagination__item">
            <a
              aria-label={`Page ${i}${
                currentPageNum === i ? ', current page' : ''
              }`}
              className={`ds_pagination__link ${
                currentPageNum === i ? 'ds_current' : ''
              }`}
              onClick={() => pageClickHandler(i)}
              href="#"
            >
              <span className="ds_pagination__link-label">{i}</span>
            </a>
          </li>
        );
      }
    } else {
      pages.push(
        <li key="ellipsis-1" className="ds_pagination__item" aria-hidden="true">
          <span className="ds_pagination__link ds_pagination__link--ellipsis">
            &hellip;
          </span>
        </li>
      );

      pages.push(
        <li key={`page-${currentPageNum - 1}`} className="ds_pagination__item">
          <a
            aria-label={`Page ${currentPageNum - 1}`}
            className="ds_pagination__link"
            onClick={() => pageClickHandler(currentPageNum - 1)}
            href="#"
          >
            <span className="ds_pagination__link-label">
              {currentPageNum - 1}
            </span>
          </a>
        </li>
      );

      pages.push(
        <li key={`page-${currentPageNum}`} className="ds_pagination__item">
          <a
            aria-label={`Page ${currentPageNum}, current page`}
            className="ds_pagination__link ds_current"
            onClick={() => pageClickHandler(currentPageNum)}
            href="#"
          >
            <span className="ds_pagination__link-label">{currentPageNum}</span>
          </a>
        </li>
      );

      if (currentPageNum < totalPagesNum - 1) {
        pages.push(
          <li
            key={`page-${currentPageNum + 1}`}
            className="ds_pagination__item"
          >
            <a
              aria-label={`Page ${currentPageNum + 1}`}
              className="ds_pagination__link"
              onClick={() => pageClickHandler(currentPageNum + 1)}
              href="#"
            >
              <span className="ds_pagination__link-label">
                {currentPageNum + 1}
              </span>
            </a>
          </li>
        );
      }

      if (currentPageNum < totalPagesNum - 2) {
        pages.push(
          <li
            key="ellipsis-2"
            className="ds_pagination__item"
            aria-hidden="true"
          >
            <span className="ds_pagination__link ds_pagination__link--ellipsis">
              &hellip;
            </span>
          </li>
        );
      }
    }
    if (totalPagesNum > 4) {
      pages.push(
        <li key={`page-${totalPagesNum}`} className="ds_pagination__item">
          <a
            aria-label={`Page ${totalPagesNum}${
              currentPageNum === totalPagesNum ? ', current page' : ''
            }`}
            className={`ds_pagination__link ${
              currentPageNum === totalPagesNum ? 'ds_current' : ''
            }`}
            onClick={() => pageClickHandler(totalPagesNum)}
            href="#"
          >
            <span className="ds_pagination__link-label">{totalPagesNum}</span>
          </a>
        </li>
      );
    }

    return pages;
  };

  return (
    <>
      <nav className="ds_pagination" aria-label="Search result pages">
        <ul className="ds_pagination__list">
          {currentPageNum > 1 && (
            <li className="ds_pagination__item">
              <a
                aria-label="Previous page"
                className="ds_pagination__link ds_pagination__link--text ds_pagination__link--icon"
                onClick={() => pageClickHandler(currentPageNum - 1)}
                href="#"
              >
                <svg className="ds_icon" aria-hidden="true" role="img">
                  <svg
                    viewBox="0 0 24 24"
                    id="chevron_left"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                  </svg>
                </svg>
                <span className="ds_pagination__link-label">Previous</span>
              </a>
            </li>
          )}

          {renderPageNumbers()}

          {currentPageNum < totalPagesNum && (
            <li className="ds_pagination__item">
              <a
                aria-label="Next page"
                className="ds_pagination__link ds_pagination__link--text ds_pagination__link--icon"
                onClick={() => pageClickHandler(currentPageNum + 1)}
                href="#"
              >
                <span className="ds_pagination__link-label">Next</span>
                <svg className="ds_icon" aria-hidden="true" role="img">
                  <svg
                    viewBox="0 0 24 24"
                    id="chevron_right"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                  </svg>
                </svg>
              </a>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
};

export default Paginator;
